import { useRuntimeConfig } from '#imports'

import type { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import type { Features } from '@backmarket/nuxt-module-marketplace/features'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { objectEntries } from '@backmarket/utils/object/objectEntries'

function isBuybackKilled(
  killGlobal: boolean,
  killCountries: string,
  killLocales: string,
  countryCode: string,
  locale: string,
): boolean {
  if (killGlobal) return true

  if (killCountries) {
    if (killCountries.toLowerCase().includes(countryCode.toLowerCase()))
      return true
  }

  if (killLocales) {
    if (killLocales.toLowerCase().includes(locale.toLowerCase())) return true
  }

  return false
}

export function useBuybackEnabled() {
  const { features, market } = useMarketplace()
  const locale = useI18nLocale()
  const { KILL_BUYBACK, KILL_BUYBACK_COUNTRIES, KILL_BUYBACK_LOCALES } =
    useRuntimeConfig().public

  const allFeatures = (useRuntimeConfig().public.marketplace?.features ??
    {}) as Record<MarketCountryCode, Features>
  const buybackAvailableMarketCodes = objectEntries(allFeatures)
    .filter(([, marketFeatures]) => marketFeatures?.buyback?.tradeInEnabled)
    .map(([marketCode]) => marketCode)

  const isKilled = isBuybackKilled(
    KILL_BUYBACK,
    KILL_BUYBACK_COUNTRIES,
    KILL_BUYBACK_LOCALES,
    market.countryCode,
    locale,
  )

  const isBuybackEnabled =
    Boolean(features.buyback?.tradeInEnabled) && !isKilled
  const isBuybackButtonEnabled =
    Boolean(features.buyback?.headerButtonEnabled) && !isKilled

  return {
    isBuybackEnabled,
    isBuybackButtonEnabled,
    buybackAvailableMarketCodes,
  }
}
